import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import type { ShareAuthCheckData } from '../../types';
import { ShareAccessCheckApi } from '../../apis/share-access-check-api';
import type { ShareAccessCheckRepository } from '../../services/share-tools-repository';

@injectable()
export class ShareAccessCheckRepositoryImpl implements ShareAccessCheckRepository {
  // eslint-disable-next-line no-useless-constructor
  constructor(@inject(ShareAccessCheckApi) private shareAccessCheckApi: ShareAccessCheckApi) {}

  shareAccessCheckForGuest(data?: ShareAuthCheckData) {
    return this.shareAccessCheckApi.shareAccessCheckForGuest(data);
  }

  shareAccessCheck(data?: ShareAuthCheckData) {
    return this.shareAccessCheckApi.shareAccessCheck(data);
  }
}
